export const TOAST_TIMEOUT = 9000;
export const MAX_EMAIL_DISPLAY_LENGTH = 50;
export const MAX_NAME_DISPLAY_LENGTH = 20;
